// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__4fXfD","additionalInfo":"AgreementModal_additionalInfo__1qjKO"};